import { cn } from 'component-library/utils';

export const MailLink = ({ email, className }: { email: string; className?: string }) => {
  return (
    <a className={cn('text-primary-100 hover:text-primary-light underline', className)} href={`mailto:${email}`}>
      {email}
    </a>
  );
};
